module.exports = __webpack_public_path__ + "img/34_38.2cac1dc6.png";